import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';

import { PipesModule } from '@shared/pipes/pipes.module';
import { EditedCellModule } from '@ui-components/components/edited-cell/edited-cell.module';
import { UserSelectDropdownModule } from '@ui-components/components/user-select-dropdown/user-select-dropdown.module';

import { TurnoverConfigurationStepAssigneesCellComponent } from './turnover-configuration-step-assignees-cell.component';

@NgModule({
  declarations: [TurnoverConfigurationStepAssigneesCellComponent],
  exports: [TurnoverConfigurationStepAssigneesCellComponent],
  imports: [
    CommonModule,
    PipesModule,
    EditedCellModule,
    UserSelectDropdownModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatCheckboxModule,
  ],
})
export class TurnoverConfigurationStepAssigneesCellModule {}
